import {
    apiConstants,
    config,
    downloadBlob,
    requestOptions,
    requestTypes,
} from "../../../../Utilities/Api";

class ServerLoanLibraryLoanReportApi {

    static getLoanLibraryLoansReport(loanLibraryLoanSearchCriteria: Record<string, unknown>) {
        const params = {
            ...loanLibraryLoanSearchCriteria,
        };
        const queryParameters = new URLSearchParams(params as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `loan-library/reports/loan/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }

    static getLoanLibraryLoanHistoryExport(loanLibraryLoanSearchCriteria: Record<string, unknown>) {
        const params = {
            ...loanLibraryLoanSearchCriteria,
        };
        const queryParameters = new URLSearchParams(params as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `loan-library/reports/loan-history/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }
}

export const loanLibraryLoanReportApi = config.environment.MODE === config.modes.SERVER ? ServerLoanLibraryLoanReportApi : ServerLoanLibraryLoanReportApi;
